import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import eventBus from '@/foundations/services/eventBus';
import axios from 'axios';
import ArticlesWithoutAudioDataTable from './ArticlesWithoutAudioDataTable.vue';
import SuggestedArticlesDataTable from './SuggestedArticlesDataTable.vue';
import ArticlesWithSyntheticAudioDataTable from './ArticlesWithSyntheticAudioDataTable.vue';
import { NewTask, Task, CreateTaskRequest } from '@ilteducation/article-publisher-types';
import config from '../../config/ConfigProvider';


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateNewArticlePublisherTaskForm',
  props: {
    tab: { default: 'articles' }
  },
  emits: ['created'],
  setup(__props: any, { emit }) {

const props = __props as { tab: string }




const tasks = ref<NewTask[]>([]);

const tab = ref<string>(props.tab);
const isCreating = ref(false);

const articleTableRef = ref<InstanceType<typeof ArticlesWithoutAudioDataTable>>();
const syntheticAudioTableRef = ref<InstanceType<typeof ArticlesWithSyntheticAudioDataTable>>();

const createTask = async () => {
  try {
    isCreating.value = true;

    let selectedArticles = [];
    if (tab.value === 'articles') {
      selectedArticles = articleTableRef.value?.selectedArticles ?? [];
    } else if (tab.value === 'syntheticAudio') {
      selectedArticles = syntheticAudioTableRef.value?.selectedArticles ?? [];
    }

    for (const article of selectedArticles) {
      const newTask: NewTask = {
        name: `${article.headline}`,
        contentId: article.id,
        language: article.content?.language ?? 'swe',
      };
      tasks.value.push(newTask);
    }

    const request: CreateTaskRequest = {
      tasks: tasks.value,
    };

    const createdTask = await axios
      .post<Task>(`${config.value('theArticlePublisherUrl')}/articles/create`, request)
      .then((res) => res.data);

    if (tab.value === 'articles') {
      articleTableRef.value?.selectedArticles.splice(0, articleTableRef.value.selectedArticles.length);
    } else if (tab.value === 'syntheticAudio') {
      syntheticAudioTableRef.value?.selectedArticles.splice(0, syntheticAudioTableRef.value.selectedArticles.length);
    }
    tasks.value.splice(0, tasks.value.length);
    emit('created');
    eventBus.$emit('snackbar.open', 'Task created successfully');
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      eventBus.$emit('snackbarV2.open', { text: `Error creating task ${error.response.data.message}`, color: 'error' });
    } else {
      const err = error as Error;
      eventBus.$emit('snackbarV2.open', { text: `Error creating task ${err.message ?? err}`, color: 'error' });
    }
  } finally {
    isCreating.value = false;
  }
};

return { __sfc: true,props, emit, tasks, tab, isCreating, articleTableRef, syntheticAudioTableRef, createTask, ArticlesWithoutAudioDataTable, SuggestedArticlesDataTable, ArticlesWithSyntheticAudioDataTable }
}

})